import { render, staticRenderFns } from "./gas.vue?vue&type=template&id=2f28674c&scoped=true&"
import script from "./gas.vue?vue&type=script&lang=js&"
export * from "./gas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28674c",
  null
  
)

export default component.exports